var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:[_vm.type, _vm.position],style:(_vm.style),attrs:{"data-only-icon":! _vm.value},on:{"click":function($event){$event.preventDefault();return _vm.action.apply(null, arguments)}}},[_c('span',{attrs:{"icon":_vm.icon}},[_vm._v(_vm._s(_vm.value))])])
}
var staticRenderFns = []

export { render, staticRenderFns }